// import { PlayerBuilder } from '../../PlayerBuilder';
import { Logger } from '@quickplay/foundation';
import { TritonAudioStreamConnectionConfig } from '../../TritonAudioStreamConnection';
import { SideBandMetadataAdapter } from './SideBandMetadataAdapter';

export const SideBandMetadataFactory = {
  createSideMetadataAdapter(
    contentUrl: string,
    audioStreamConnectionConfig: TritonAudioStreamConnectionConfig,
    logger: Logger,
  ): SideBandMetadataAdapter | undefined {
    if (!audioStreamConnectionConfig.sidebandMetadataUrl) {
      return undefined;
    }
    return new SideBandMetadataAdapter(contentUrl, audioStreamConnectionConfig, logger);
  },
};
